// MAIN //

class Group {
	constructor( name, members ) {
		this.name = name;
		this.members = members;
	}
}


// EXPORTS //

export default Group;
